import React from "react";
import { Route } from "react-router-dom";

export const PrivateRoute = ({ path, exact, component, children }) => {
    
    return (
      <Route path={path} exact={exact} component={component}>{children}</Route>
    ) 
      
};